import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { TypeaheadContext } from '../typeahead-context';
import { returnDefiningProp } from '../typeahead';

/**
 * @typedef Props
 * @prop {string | {}} [item]]
 * @prop {number} [index]
 */
/**
 * @param {Props} props
 */
const TypeaheadOption = ({ item = '', index = 0 }) => {
  const { value, currentOption, id, handleOnSelect, template: Template, filterProp } = useContext(
    TypeaheadContext
  );
  const optionRef = useRef();

  useEffect(() => {
    if (index === currentOption) {
      optionRef.current.focus();
    }
  }, [currentOption]);

  const handleOnClickOption = event => {
    if (!item.disabled) {
      handleOnSelect(returnDefiningProp(item, filterProp));
    }
  };

  const classes = classNames({
    'motif-typeahead-list-item': true,
    'motif-typeahead-list-item-focus': index === currentOption,
    'motif-typeahead-list-item-disabled': item.disabled
  });

  const itemValue = returnDefiningProp(item, filterProp);

  return (
    <li
      tabIndex={index === currentOption ? '0' : '-1'}
      ref={optionRef}
      role="option"
      id={`${id}-option-${index}`}
      aria-disabled={item.disabled}
      className={classes}
      onClick={handleOnClickOption}
      onMouseDown={event => event.preventDefault()}
    >
      <Template item={item} searchTerm={value} value={itemValue} />
    </li>
  );
};

TypeaheadOption.propTypes = {
  index: PropTypes.number,
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export { TypeaheadOption };
